import React from "react";
import { Droplets, Phone, MapPin, Clock } from "lucide-react";

const Footer = () => {
  return (
    <footer
      data-testid="main-footer"
      className="relative z-10 border-t border-white/5 bg-slate-950/60 backdrop-blur-xl mt-24"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <Droplets className="w-6 h-6 text-cyan-400" strokeWidth={2.2} />
            <span className="font-display font-black text-lg tracking-tight">
              DMB<span className="text-cyan-400"> </span>S.r.l.
            </span>
          </div>
          <p className="text-sm text-slate-400 leading-relaxed font-body">
            Lavaggio self-service professionale in Friuli Venezia Giulia.
            Tecnologia, schiuma e brillantezza — 24 ore su 24, ogni giorno.
          </p>
        </div>

        <div>
          <h4 className="font-display font-bold text-white mb-4 uppercase text-xs tracking-[0.18em]">
            Sede di Villesse
          </h4>
          <ul className="space-y-2 text-sm text-slate-400 font-body">
            <li className="flex items-start gap-2">
              <MapPin className="w-4 h-4 text-cyan-400 mt-0.5 flex-shrink-0" />
              Via Massimiliano Fremaut 2, Villesse (GO)
            </li>
            <li className="flex items-start gap-2">
              <Phone className="w-4 h-4 text-cyan-400 mt-0.5 flex-shrink-0" />
              +39 345 054 8060
            </li>
            <li className="flex items-start gap-2">
              <Clock className="w-4 h-4 text-cyan-400 mt-0.5 flex-shrink-0" />
              Aperto 24/7
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-white mb-4 uppercase text-xs tracking-[0.18em]">
            Sede di Tavagnacco
          </h4>
          <ul className="space-y-2 text-sm text-slate-400 font-body">
            <li className="flex items-start gap-2">
              <MapPin className="w-4 h-4 text-cyan-400 mt-0.5 flex-shrink-0" />
              Via Guglielmo Marconi 88, Tavagnacco (UD)
            </li>
            <li className="flex items-start gap-2">
              <Phone className="w-4 h-4 text-cyan-400 mt-0.5 flex-shrink-0" />
              +39 345 054 8060
            </li>
            <li className="flex items-start gap-2">
              <Clock className="w-4 h-4 text-cyan-400 mt-0.5 flex-shrink-0" />
              Aperto 24/7
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-slate-500 font-body">
          <span>© {new Date().getFullYear()} DMB S.r.l. — Tutti i diritti riservati.</span>
          <span>Realizzato con cura in Friuli Venezia Giulia 🇮🇹</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
